import { BookOpen } from "lucide-react";

const WhyExists = () => {
  return (
    <section id="why-exists" data-testid="why-exists-section" className="section-primary">
      <div className="section-pattern"></div>
      <div className="container narrow centered">
        <div className="section-header">
          <div className="section-icon">
            <BookOpen />
          </div>
          <h2 className="section-title">Education Before Execution</h2>
          <div className="section-divider"></div>
        </div>
        
        <p className="body-text">
          AI-powered tools, trading platforms, and Web3 systems are evolving faster than most people 
          can meaningfully understand or use responsibly. FLEXX Academy exists to create structure 
          before scale—helping individuals and communities develop clarity, discipline, and sound 
          decision-making before engaging with advanced trading and digital asset technologies.
        </p>
        
        <p className="gold-statement">
          This is about <span className="gold">preparation, not promotion</span>.
        </p>
      </div>
    </section>
  );
};

export default WhyExists;
